import { useDeleteDevice } from '../hooks/useDeleteDevice'
import { useLightMode } from '@/hooks/useLightMode'
import { usePermissions } from '@/hooks/usePermissions'
import { useTranslation } from 'react-i18next'

import { Alert, Box, Modal } from '@hivewatch/dark'

import { DeviceType } from '@/graphql/generated/schemas'
import { tVar } from '@/utils/i18n'

import { getDeviceTypeMessage } from '../utils/utils'

interface DarkDeleteDeviceModalIProps {
  isOpen: boolean
  onClose: () => void
  deviceId: string
  deviceType: DeviceType
}

export const DarkDeleteDeviceModal = ({
  isOpen,
  onClose,
  deviceId,
  deviceType,
}: DarkDeleteDeviceModalIProps) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const { shouldEnableDeleteDevice } = usePermissions()
  const device = getDeviceTypeMessage(deviceType)
  const { deleteDevice, isLoading } = useDeleteDevice({
    deviceId,
    device,
    onClose,
  })

  return (
    <Modal
      closeOnEsc={!isLoading}
      closeOnOverlayClick={!isLoading}
      colorScheme={colorScheme}
      isCloseHidden={isLoading}
      isOpen={isOpen}
      isSaveDestructive
      isSaveDisabled={isLoading || !shouldEnableDeleteDevice}
      isSaveLoading={isLoading}
      onCancel={onClose}
      onClose={onClose}
      onSave={deleteDevice}
      saveButtonLabel={t('common:delete')}
      showCancelButton={!isLoading}
      size='compact'
      title={tVar(t, 'devices:crud_delete_title', { device })}
    >
      <Box data-testid='DarkDeleteDeviceModal:message'>
        {tVar(t, 'devices:crud_delete_confirm', { device })}
      </Box>
      <Box mt='16px'>
        <Alert
          colorScheme={colorScheme}
          description={t('devices:crud_delete_warning')}
          title={t('common:warning')}
          variant='warning'
        />
      </Box>
    </Modal>
  )
}
